import React, { Component } from 'react';
import './Post.less';

import PropTypes from 'prop-types';
import Parser from './MarkdownParser.js';

import CloseIcon from 'react-icons/lib/fa/times-circle';

class Post extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired
    };

    state = {
        isLoading: true,
        showAll: false,
        content: {
            __html: ""
        }
    };

    async componentDidMount() {
        const { url } = this.props;

        try {
            let response = await fetch(url);
            let data = await response.text();

            var parser = new Parser();
            var parsedData = parser.toHTML(data);

            this.setState(
                {
                    isLoading: false,
                    content: {
                        __html: parsedData
                    }
                }
            );
        }
        catch (error) {
            console.log(error);
        }
    }

    onToggleOpen() {
        this.setState({
            showAll: !this.state.showAll
        });
    }

    onClickClose() {
        this.setState({
            showAll: false
        });
    }

    onTitleClicked() {
        const { maximize, name } = this.props;
        const { showAll } = this.state;
        
        if (!maximize && !showAll) {
            this.onToggleOpen();
        }

        if (!maximize && showAll) {
            window.location.href = `?post=${name}`;
        }
    }

    render() {
        const { title } = this.props;
        const { date } = this.props;
        const { maximize } = this.props;
        const { isLoading } = this.state;
        const { content } = this.state;
        const { showAll } = this.state;

        return (
            <div className="post">
                <div className="post-header">
                    <div className="post-date">{ date }</div>
                    <div className="post-title"
                         onClick={ this.onTitleClicked.bind(this) }>
                        { title }
                    </div>
                    <button className={ "button close-button " + (showAll && !maximize ? "" : "hidden") }
                            onClick={ this.onClickClose.bind(this) }>
                        <CloseIcon></CloseIcon>
                    </button>
                </div>
                <div className="post-body">
                    <div className={ showAll || maximize ? "post-content-full" : "post-content-small" }
                         dangerouslySetInnerHTML={ isLoading ? { __html: "Loading..." } : content } />
                    <div className={ showAll || maximize ? "hidden" : "post-overlay" } 
                         onClick={ this.onToggleOpen.bind(this) } />
                </div>
                <div className={ showAll || maximize ? "hidden" : "fade" }
                     onClick={ this.onToggleOpen.bind(this) } />
            </div>
        );
    }
}

export default Post;



// WEBPACK FOOTER //
// ./src/Post/Post.js